module.exports = __webpack_public_path__ + "components/bookings-payment/static/shield-93301102179f5e8576fd4dede7a6a815.svg";